export default {
  state: {
    voiceOver: undefined
  },
  mutations: {
    setVoiceOver(state, payload) {
      state.voiceOver = payload;
    }
  }
};
